export default __webpack_public_path__ + "media/zurb/img/icons/favicon/apple-touch-icon-152x152-31ef2b25d2bb4f365b3c4cad7a7a1c34.png";